import { IRouteConfig } from '@/router/types';

export default [
  {
    path: '/user',
    name: 'User',
    component: () => import('@/layouts/main/index.vue'),
    redirect: '/user',
    meta: {
      title: '用户管理',
    },
    children: [
      {
        path: '',
        name: 'UserList',
        component: () => import('./user/list.vue'),
        meta: {
          title: '用户管理',
          auth: true,
          isKeepAlive: true,
        },
      },
      {
        path: '/user/:id',
        name: 'UserDetail',
        component: () => import('./user/detail.vue'),
        meta: {
          title: '用户详情',
          auth: true,
          activeMenu: 'UserList',
          isKeepAlive: false,
        },
      },
      {
        path: 'open-user',
        name: 'OpenUserList',
        component: () => import('./open-user/index.vue'),
        meta: {
          title: '开放平台用户',
          auth: true,
          isKeepAlive: true,
        },
      },
      {
        path: 'org',
        name: 'UserOrgList',
        component: () => import('./org/index.vue'),
        meta: {
          title: '组织管理',
          auth: true,
          isKeepAlive: true,
        },
      },
      {
        path: 'org-change-history',
        name: 'UserOrgChangeHistory',
        component: () => import('./org-change-history/index.vue'),
        meta: {
          title: '组织变更历史',
          auth: true,
          isKeepAlive: true,
        }
      },
      {
        path: 'user-tag',
        name: 'UserTag',
        component: () => import('./user-tag/index.vue'),
        meta: {
          title: '用户标签管理',
          auth: true,
          isKeepAlive: true,
        },
      },
    ],
  },
] as IRouteConfig[];
